/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import './reports.css';
import Header from '../common/Header';
import { HeaderTypes, ActivityType } from '../../global/Enum';
import Loader from '../common/loader/Loader';
import DesktopFooter from '../common/DesktopFooter';
import ApiServices from '../../providers/ApiServices';
import Utilities from '../../global/Utilities';
import { COMMON, ALL_ROUTES } from '../../global/Constants';
import SyncLoader from '../common/loader/SyncLoader';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import moment from 'moment';
// import SyncServices from '../../providers/SyncServices';
import MapContainer from './MapContainer';

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 8,
        slidesToSlide: 3
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
        slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    }
};

class FarmerReport extends Component {

    constructor(props) {
        super(props)
        this.state = {
            farmerData: {},
            isLoading: false,
            regexp: /^[0-9]/,
            imagePopUp: false,
            fields: {
                mobile: ""
            },
        }
    }

    componentDidMount() {
        setTimeout(this._validateCode, 1000);
    }


    _validateCode = () => {
        let code = "";
        let referralCode = this.props.location.search;
        if (referralCode !== undefined && referralCode.length > 0) {
            referralCode = referralCode.replace("?", "");
            let parts = referralCode.split("=");
            if (parts.length === 2 && parts[0].toLowerCase() === "mobile" && parts[1].length > 0) {
                code = parts[1];
            }
        }

        if (code.length > 0) {
            let fields = this.state.fields;
            fields["mobile"] = code;
            this.setState({ fields });
            this.farmerReportApi(code);
        }
    }

    _getFieldValue(fieldName, defaultValue) {
        const { fields } = this.state;
        let value = fields[fieldName];
        if (value === null || typeof value === "undefined") {
            value = defaultValue;
        }
        return value;
    }

    _handleValueChange = (field, e) => {

        let telephone = e.target.value;
        if (telephone === '' || this.state.regexp.test(telephone)) {
            let fields = this.state.fields;
            fields[field] = telephone;
            this.setState({ fields });
            if (telephone.length === 10) {
                this.farmerReportApi(telephone);
            } else {
                this.setState({ farmerData: {} });
            }
        }
    };

    //ALL ACTIONS
    handleDataPrint = () => {
        window.print();
    }

    handleImageClick = (item) => {
        this.setState({ imagePopUp: true });
    }

    onMobileNumberClick = (e, number) => {
        e.preventDefault();
        let fields = {
            mobile: number
        }
        this.setState({ fields }, () => {
            this.farmerReportApi(number);
        });
    }

    getActivityRoute(activity) {
        if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity.retailer_id === 0) {
            return ALL_ROUTES.INDIVIDUAL_VISIT_DETAILS_ROUTE;
        } else if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity.retailer_id !== 0) {
            return ALL_ROUTES.INDIVIDUAL_VISIT_DETAILS_ROUTE;
        } else if (activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION) {
            return ALL_ROUTES.SAMPLE_DISTRIBUTION_DETAILS_ROUTE;
        } else if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
            return ALL_ROUTES.GROUP_MEETING_DETAILS_ROUTE;
        } else if (activity.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
            return ALL_ROUTES.GROUP_MEETING_DETAILS_ROUTE;
        } else {
            return ALL_ROUTES.FARMER_REPORTS_ROUTE;
        }
    }

    getActivityRedirectUrl(activity) {
        Utilities.LogPrint("handleActivityClick", activity);
        let selectedDate = moment(activity.created_at).toDate();
        if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity.retailer_id === 0) {
            return {
                pathname: ALL_ROUTES.INDIVIDUAL_VISIT_DETAILS_ROUTE,
                state: { isFarmer: true, data: activity, selectedDate: selectedDate }
            }
        } else if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity.retailer_id !== 0) {
            return {
                pathname: ALL_ROUTES.INDIVIDUAL_VISIT_DETAILS_ROUTE,
                state: { isFarmer: false, data: activity, selectedDate: selectedDate }
            };
        } else if (activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION) {
            return {
                pathname: ALL_ROUTES.SAMPLE_DISTRIBUTION_DETAILS_ROUTE,
                state: { data: activity, selectedDate: selectedDate }
            };
        } else if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
            return {
                pathname: ALL_ROUTES.GROUP_MEETING_DETAILS_ROUTE,
                state: { data: activity, selectedDate: selectedDate }
            };
        } else if (activity.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
            return {
                pathname: ALL_ROUTES.SAMPLE_TO_SALE_DETAILS_ROUTE,
                state: { data: activity, selectedDate: selectedDate }
            };
        }
    }

    handleActivityClick(e, activity) {
        e.preventDefault();
        Utilities.LogPrint("handleActivityClick", activity);

        let selectedDate = moment(activity.created_at).toDate();

        if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity.retailer_id === 0) {
            this.props.history.push({
                pathname: ALL_ROUTES.INDIVIDUAL_VISIT_DETAILS_ROUTE,
                state: { isFarmer: true, data: activity, selectedDate: selectedDate }
            });

        } else if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity.retailer_id !== 0) {
            this.props.history.push({
                pathname: ALL_ROUTES.INDIVIDUAL_VISIT_DETAILS_ROUTE,
                state: { isFarmer: false, data: activity, selectedDate: selectedDate }
            });

        } else if (activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION) {
            this.props.history.push({
                pathname: ALL_ROUTES.SAMPLE_DISTRIBUTION_DETAILS_ROUTE,
                state: { data: activity, selectedDate: selectedDate }
            });

        } else if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
            this.props.history.push({
                pathname: ALL_ROUTES.GROUP_MEETING_DETAILS_ROUTE,
                state: { data: activity, selectedDate: selectedDate }
            });

        } else if (activity.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
            this.props.history.push({
                pathname: ALL_ROUTES.SAMPLE_TO_SALE_DETAILS_ROUTE,
                state: { data: activity, selectedDate: selectedDate }
            });
        } else {
            this.props.history.push({
                pathname: ALL_ROUTES.KRISHAK_INFO_ROUTE,
                state: { krishak_id: activity.krishak_id === 0 ? activity.temp_krishak_id : activity.krishak_id }
                //state: { krishak_id: this.state.krishakInfo.krishak_id }
            });
        }
    }

    //API CALL
    farmerReportApi(mobile) {
        // const mobile = this._getFieldValue("mobile", "");

        // SyncServices.findKrishakFromDatabase("key", mobile).then(data => {
        //     if (data) {
        //         Utilities.LogPrint("farmerReport-Response", data);
        //         this.setState({ farmerData: data })
        //     }
        // });

        var param = JSON.stringify({
            phone: mobile,
        });
        this.setState({ isLoading: true });
        try {
            ApiServices.farmerReport(param)
                .then(response => {
                    var status = response.success;
                    this.setState({ isLoading: false });
                    if (status) {
                        Utilities.LogPrint("farmerReport-Response", response.data);
                        this.setState({ farmerData: response.data, decisionMakingPoint: response.data.krishak_decision_making ? response.data.krishak_decision_making.name : "" });
                    } else {
                        Utilities.LogPrint("farmerReport-Status", response.message);
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                })
                .catch(error => {
                    this.setState({ isLoading: false });
                    Utilities.LogPrint("farmerReport-Error", error);
                });
        }
        catch (error) {
            this.setState({ isLoading: false });
            Utilities.LogPrint("farmerReport-Error", error);
        }
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName)
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {

        const style = {
            image: {
                width: '100px',
                height: '100px'
            }
        }
        const mobile = this._getFieldValue("mobile", "");
        const { isSyncLoading, tableName } = this.state;
        const { farmerData, isLoading, decisionMakingPoint } = this.state;
        var totalActivites = farmerData.activities?.length;
        var totalCroppingArea = parseFloat(farmerData.rainfed) + parseFloat(farmerData.irrigated);

        let appsArray = [];
        let activityList = [];
        let retailersArray = [];
        let activitiesArray = [];
        var nearestDR = "";
        var influencingFactors = "";
        var newImageObjects = (farmerData.krishak_images !== undefined) ? farmerData.krishak_images : [];

        var totalCropArea = 0;
        if (farmerData.krishak_crops_planteds !== undefined) {
            farmerData.krishak_crops_planteds.forEach(function (crop) {
                totalCropArea += parseFloat(crop.planted_area);
            });
        }

        if (farmerData.krishak_near_retailers !== undefined) {
            for (var j = 0; j < farmerData.krishak_near_retailers.length; j++) {
                const retailer = farmerData.krishak_near_retailers[j].retailer;
                retailersArray.push({
                    "id": retailer.retailer_id,
                    "name": retailer.retailer_name,
                    "location": {
                        "lat": parseFloat(retailer.lat),
                        "lng": parseFloat(retailer.long)
                    }
                });
            }
        }

        if (farmerData.activities !== undefined) {
            activityList = farmerData.activities;
            activityList.push({
                activity_type_name: "Krishak",
                activity_type_id: "111",
                created_at: farmerData.created_at,
                sub_activity: "",
                season_name: "",
                krishak_id: farmerData.krishak_id,
                temp_krishak_id: farmerData.temp_krishak_id
            });
            for (let j = 0; j < farmerData.activities.length; j++) {
                const activity = farmerData.activities[j];

                if (activity.latitude && activity.longitude) {
                    activitiesArray.push({
                        "id": activity.activity_type_id,
                        "name": activity.activity_type_name,
                        "location": {
                            "lat": parseFloat(activity.latitude),
                            "lng": parseFloat(activity.longitude)
                        }
                    });
                }
            }
        }

        if (farmerData.phone_app !== undefined) {
            for (let j = 0; j < farmerData.phone_app.length; j++) {
                appsArray.push(farmerData.phone_app[j].name);
            }
        }

        if (farmerData.krishak_near_retailers !== undefined) {
            for (let j = 0; j < farmerData.krishak_near_retailers.length; j++) {
                nearestDR += farmerData.krishak_near_retailers[j].retailer.retailer_name + ", "
            }
        }

        if (farmerData.krishak_influence_factors !== undefined) {
            for (let j = 0; j < farmerData.krishak_influence_factors.length; j++) {
                influencingFactors += farmerData.krishak_influence_factors[j].influence_factor.name + ", "
            }
        }
        var farmerImageUrl = (farmerData.krishak_images !== undefined) ? farmerData.krishak_images[0]?.image_url : "";

        var cropList = (farmerData.krishak_crops_planteds !== undefined) ? farmerData.krishak_crops_planteds : [];
        var numbersList = (farmerData.krishak_fellow_farmer_phones !== undefined) ? farmerData.krishak_fellow_farmer_phones : [];
        var swHybridList = (farmerData.krishak_hybrid_purchaseds !== undefined) ? farmerData.krishak_hybrid_purchaseds : [];
        var competitorList = (farmerData.krishak_other_brands !== undefined) ? farmerData.krishak_other_brands : [];

        const cropDataListItem = cropList.map((crop, i) =>
            <tr key={i}>
                <td>{crop.crop_name}</td>
                <td>{crop.planted_area} acres</td>
            </tr>
        );

        const fellowFarmerNumbersListItem = numbersList.map((number, i) =>

            <tr key={i}>
                <td><a href="#" onClick={(e) => this.onMobileNumberClick(e, number.phone)}>{number.phone}</a></td>
            </tr>
        );

        const swHybridListItem = swHybridList.map((hybrid, i) =>

            <tr key={i}>
                <td>{hybrid.hybrid_name}</td>
                <td>{hybrid.crop_name}</td>
                <td>{(hybrid.quantity !== null) ? hybrid.quantity : 0} {hybrid.weight_unit_name}</td>
            </tr>
        );

        const competitorHybridListItem = competitorList.map((hybrid, i) =>

            <tr key={i}>
                <td>{hybrid.hybrid_name}</td>
                <td>{hybrid.crop_name}</td>
                <td>{hybrid.quantity} {hybrid.weight_unit_name}</td>
            </tr>
        );

        const activityListItem = activityList.map((activity, i) =>

            <tr key={i}>
                <td>{new Date(activity.created_at).getFullYear()}</td>
                <td>{Utilities.formatDate(activity.created_at)}</td>
                <td><button className={(activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT) ? "btn-yellow w-75 text-left" : (activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION) ? "btn-brown w-75 text-left" : (activity.activity_type_id === ActivityType.GROUP_MEETING) ? "btn-blue w-75 text-left" : (activity.activity_type_id === ActivityType.SAMPLE_TO_SALE) ? "btn-green w-75 text-left" : "btn-red w-75 text-left"}>{activity.activity_type_name}</button></td>
                <td>{activity.sub_activity}</td>
                <td>{activity.season_name}</td>
                {/* <td><Link
                    to={this.getActivityRedirectUrl(activity)}
                    target="_blank"
                >link</Link></td> */}
                <td><a href="#" onClick={(e) => this.handleActivityClick(e, activity)}>link</a></td>
            </tr>
        );


        return (
            <div>
                <Header selectedTab={HeaderTypes.REPORTS} handleSyncLoading={this.handleSyncLoading} />
                <div className="container pt-35 pb-65">
                    <h1>{COMMON.FARMER_REPORT}</h1>

                    <div className="row align-items-center">

                        <div className="col-md-3 col-12">

                            <div className="form-group">
                                <input type="number" className="form-control" placeholder="Mobile Number of Farmer" value={mobile} onChange={this._handleValueChange.bind(this, "mobile")} />
                            </div>
                        </div>

                        <div className="col-md-3 pl-0 col-12 d-flex">
                            <div className="form-group">
                                <span className="user-name">{farmerData.name}<br />{Utilities.calculateAge(farmerData?.dob)}</span>
                            </div>
                            <div>
                                <img src="../assets/images/tick.png" alt="tick-img" className="img-fluid ml-4" />
                            </div>
                        </div>
                        <div className="col-lg-6 d-md-flex back-btn d-none align-items-center">
                            <div>
                                {/* <div className="text-right">
                                    <i className="customic pdf"></i>
                                </div> */}
                                <label>
                                    Total Activites
                                    <input type="text" className="form-control activites ml-2" placeholder={totalActivites} disabled />
                                </label>


                            </div>
                            <div className="image-info w-25 ml-2">
                                <img src={farmerImageUrl} alt="" />
                            </div>

                        </div>
                    </div>
                    {/* <form> */}
                    <form action="">

                        <div className="row mt-4">
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <input type="text" className="form-control max-w-360" placeholder={farmerData.state_name ? farmerData.state_name : "State"} disabled />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <input type="text" className="form-control max-w-360" placeholder={farmerData.district_name ? farmerData.district_name : "District"} disabled />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <input type="text" className="form-control max-w-360" placeholder={farmerData.tehsil_name ? farmerData.tehsil_name : "Tehsil"} disabled />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <input type="text" className="form-control max-w-360" placeholder={farmerData.village_name ? farmerData.village_name : "Village"} disabled />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <input type="text" value={moment(farmerData.dob, "YYYY-MM-DD").format("DD-MM-YYYY")} className="form-control" placeholder="DBO" disabled />
                                </div>
                            </div>

                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <input type="text" className="form-control" placeholder={farmerData.qualification ? farmerData.qualification : "Education"} disabled />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <input type="text" className="form-control" placeholder={farmerData.irrigation_source_name ? farmerData.irrigation_source_name : "Irrigation Source"} disabled />
                                </div>
                            </div>
                            <div className="col-md-3 col-12">
                                <div className="form-group">
                                    <input type="text" className="form-control" placeholder={appsArray.length !== 0 ? appsArray.toString() : "Apps Used"} disabled />
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="table-responsive table-height">
                                <table id="farmerReport" className=" display table  table-striped table-bordered w-100">
                                    <thead>
                                        <tr>
                                            <th colSpan="2" className="font-weight-medium">Cropping</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colSpan="2">Cropping Area</td>
                                        </tr>
                                        <tr>
                                            <td>Irrigated</td>
                                            <td>{farmerData.irrigated} acres</td>
                                        </tr>
                                        <tr>
                                            <td>Rainfed</td>
                                            <td>{farmerData.rainfed} acres</td>
                                        </tr>
                                        <tr>
                                            <td>Total</td>
                                            <td>{totalCroppingArea} acres</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="table-responsive table-height">
                                <table id="farmerReport" className="display table  table-striped table-bordered w-100">
                                    <thead>
                                        <tr>
                                            <th colSpan="3" className="font-weight-medium">Brand Loyalty</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>SW Hybrid</td>
                                            <td>Crop</td>
                                            <td>Qty</td>
                                        </tr>
                                        {swHybridListItem}


                                    </tbody>
                                </table>
                            </div>

                        </div>


                        <div className="col-md-6">
                            <div className="table-responsive mt-4 table-height">
                                <table id="farmerReport" className="display table  table-striped table-bordered w-100">
                                    <thead>
                                        <tr>
                                            <th colSpan="2" className="font-weight-medium">Cropping</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colSpan="2">Crop</td>
                                        </tr>
                                        {cropDataListItem}
                                        <tr>
                                            <td>Total</td>
                                            <td>{totalCropArea} acres</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="table-responsive mt-4 table-height">
                                <table id="farmerReport" className="display table  table-striped table-bordered w-100">
                                    <thead>
                                        <tr>
                                            <th colSpan="3" className="font-weight-medium">Brand Loyalty</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Competitor Hybrid</td>
                                            <td>Crop</td>
                                            <td>Qty</td>
                                        </tr>
                                        {competitorHybridListItem}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 activity">
                            <div className="table-responsive mt-4 table-height">
                                <table id="farmerReport" className="display table  table-striped table-bordered w-100">
                                    <thead>
                                        <tr>
                                            <th colSpan="6" className="font-weight-medium">Activites</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Year</td>
                                            <td>Date</td>
                                            <td>Activity</td>
                                            <td>SubActivity</td>
                                            <td>Hybrid</td>
                                            <td></td>
                                        </tr>
                                        {activityListItem}
                                        {/* <tr>
                                            <td>2018</td>
                                            <td>01/12/2018</td>
                                            <td><button className="btn-green w-75 text-left">Sample To Sale</button></td>
                                            <td></td>
                                            <td></td>
                                            <td><a href="#">link</a></td>
                                        </tr>
                                        <tr>
                                            <td>2019</td>
                                            <td>01/12/2019</td>
                                            <td><button className="btn-yellow w-75 text-left">Individual Visit</button></td>
                                            <td>Product Advisory</td>
                                            <td>US 51</td>
                                            <td><a href="#">link</a></td>
                                        </tr>
                                        <tr>
                                            <td>2019</td>
                                            <td>01/12/2019</td>
                                            <td><button className="btn-blue w-75 text-left">Group Meeting</button></td>
                                            <td>Field Day</td>
                                            <td>US 71</td>
                                            <td><a href="#">link</a></td>
                                        </tr>
                                        <tr>
                                            <td>2019</td>
                                            <td>01/12/2019</td>
                                            <td><button className="btn-brown w-75 text-left">Sample Distribution</button></td>
                                            <td></td>
                                            <td>US 81</td>
                                            <td><a href="#">link</a></td>
                                        </tr>
                                        <tr>
                                            <td>2019</td>
                                            <td>01/12/2019</td>
                                            <td><button className="btn-yellow w-75 text-left">Individual Visit</button></td>
                                            <td>Product Advisory</td>
                                            <td>US 81</td>
                                            <td><a href="#">link</a></td>
                                        </tr> */}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6  ifPrerak">
                            <div className="table-responsive mt-4 table-height">

                                <table id="farmerReport" className=" display table  table-striped table-bordered w-100">
                                    <thead>
                                        <tr>
                                            <th colSpan="3" className="font-weight-medium">If Prerak</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Nearest Agri Distributor/retailer</td>
                                            <td>{nearestDR}</td>
                                        </tr>
                                        <tr>
                                            <td>Factors influencing purchase intention</td>
                                            <td>{influencingFactors}</td>
                                        </tr>
                                        <tr>
                                            <td>Point of Decision making</td>
                                            <td>{decisionMakingPoint}</td>
                                        </tr>
                                        <tr>
                                            <td>Favourite TV show</td>
                                            <td>{farmerData.favourite_tv}</td>
                                        </tr>
                                        <tr>
                                            <td>Favourite Radio Show</td>
                                            <td>{farmerData.favourite_radio}</td>
                                        </tr>
                                        <tr>
                                            <td>Favourite Newspaper</td>
                                            <td>{farmerData.favourite_news}</td>
                                        </tr>
                                        <tr>
                                            <td>GPS Co-ordinates</td>
                                            <td>{farmerData.latitude}, {farmerData.longitude}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="col-md-6 farmer-number">
                            <div className="table-responsive mt-4 table-height">

                                <table id="farmerReport" className="display table mobile-number  table-striped table-bordered w-100">
                                    <thead>
                                        <tr>
                                            <th colSpan="3" className="font-weight-medium">Fellow Farmer mobile Number</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {fellowFarmerNumbersListItem}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col mt-4">
                            <table id="farmerReport" className=" display table  table-striped table-bordered w-100">
                                <thead>
                                    <tr>
                                        <th colSpan="3" className="font-weight-medium">Images</th>
                                    </tr>
                                </thead>
                                <tbody>

                                </tbody>
                            </table>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col">
                            <Carousel
                                ssr
                                partialVisbile
                                itemclassName="image-item"
                                responsive={responsive}
                                draggable={true}
                                sliderclassName="react-multi-carousel-track"
                                swipeable={true}>

                                {newImageObjects.slice(0, 9).map(image => {
                                    return (
                                        <img key={image.image_url} src={image.image_url} style={style.image} alt={image.image_name} />
                                    )
                                })}
                            </Carousel>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-6">
                            <p className="font-weight-medium">Activities</p>
                            <MapContainer locations={activitiesArray} className="img-fluid" />
                        </div>
                        <div className="col-md-6">
                            <p className="font-weight-medium">Nearest Retailers</p>
                            <MapContainer locations={retailersArray} className="img-fluid" />
                        </div>
                    </div>
                </div>
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                {isLoading ? <Loader /> : null}
                <DesktopFooter />
            </div>
        )
    }
}


export default withRouter(FarmerReport)

